module.exports = __webpack_public_path__ + "img/lasegunda.7b14a4e9.png";